import { useRef, useState } from 'react';
import { Link } from "react-router-dom";
import './index.scss'
import AnimatedLetters from "../AnimatedLetters";
// import Logo from './Logo'
import Loader from 'react-loaders';

const Home = () => {
    const [letterClass, setLetterClass] = useState('text-animate')
    const nameArray = [' ','K', 'a', 'r', 'i', '.']
    const jobArray = ['A', ' ', 'f', 'r', 'o', 'n', 't','e','n','d', ' ', 'd', 'e', 'v', 'e', 'l', 'o', 'p', 'e', 'r', '.']

    setTimeout(() => {setLetterClass('text-animate-hover')}, 4000)


    


    return (
        <>
        <div className="container home-page">
            <div className="text-zone">
                <h1>
                <span className={letterClass}>H</span>
                <span className={`${letterClass} _12`}>e</span>
                <span className={`${letterClass} _13`}>l</span>
                <span className={`${letterClass} _14`}>l</span>
                <span className={`${letterClass} _15`}>o</span>
                <br/> 
                <span className={`${letterClass} _16`}>I</span>
                <span className={`${letterClass} _17`}>'m</span>
                 
                <AnimatedLetters 
                letterClass={letterClass}
                strArray={nameArray}
                idx={15} /> 
                
                <br />
                <AnimatedLetters 
                letterClass={letterClass}
                strArray={jobArray}
                idx={22} /> 

                </h1>
                <h2> Frontend developer / Mains React, Javascript (ES6), HTML5, CSS3, and more. Community Builder </h2>
                <Link to="/contact" className='flat-button'>CONTACT ME</Link>
            </div>
        </div>
        <Loader type="ball-scale-multiple" ></Loader>

        </>

        
    )
}
export default Home